import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type SectionType =
  | 'header'
  | 'hero'
  | 'features'
  | 'cards'
  | 'testimonials'
  | 'pricing'
  | 'faq'
  | 'bottomNav'
  | 'footer';

export type MobileSectionType =
  | 'tabBar'
  | 'drawer'
  | 'splashScreen'
  | 'listFeed'
  | 'detailScreen'
  | 'form'
  | 'modal'
  | 'loadingState'
  | 'emptyState'
  | 'errorScreen';

export type AnySection = SectionType | MobileSectionType;

export type DensityType = 'minimal' | 'standard' | 'rich';

interface SectionsBuilderState {
  selectedSections: AnySection[];
  density: DensityType;
  isExpanded: boolean;

  toggleSection: (section: AnySection) => void;
  setDensity: (density: DensityType) => void;
  setExpanded: (expanded: boolean) => void;
  clearSections: () => void;
}

export const useSectionsBuilderStore = create<SectionsBuilderState>()(
  persist(
    (set, get) => ({
      selectedSections: [],
      density: 'standard',
      isExpanded: false,

      toggleSection: (section) => {
        const { selectedSections } = get();
        if (selectedSections.includes(section)) {
          set({ selectedSections: selectedSections.filter((s) => s !== section) });
        } else {
          set({ selectedSections: [...selectedSections, section] });
        }
      },

      setDensity: (density) => set({ density }),
      setExpanded: (isExpanded) => set({ isExpanded }),
      clearSections: () => set({ selectedSections: [] }),
    }),
    {
      name: 'sections-builder',
      partialize: (state) => ({
        selectedSections: state.selectedSections,
        density: state.density,
        isExpanded: state.isExpanded,
      }),
    }
  )
);
